/** @ignore *//** */
const config = {
  version: '2.17.1',
  type: 'js'
};

export default config;